//TODO: https://localforage.github.io/localForage/
//TODO: VUE localstorage extended - https://github.com/ricardogobbosouza/v-localforage
import { defineModule } from "direct-vuex"
import store, { moduleActionContext, moduleGetterContext } from "."
import { OrderingListPendingProductRequestViewModel, AddOrderingListRequestProductCommand, ApproveOrderingListRequestProductCommand, CancelOrderingListRequestProductCommand} from "Api/CoreApi";
import ApiFactory from "Api/ApiFactory";
import { UserPermission } from "Api/DynamicwebApi";


export interface IOrderingListRequestProductState {
    list: OrderingListPendingProductRequestViewModel[]
}


const initial : IOrderingListRequestProductState = {
    list : null,
    
}

let promise: Promise<any>;
const orderingListRequestProduct = defineModule({
    namespaced: true,
    state: (): IOrderingListRequestProductState => initial
    ,
    getters: {
    },
    mutations: {
        SET_List(state, list: OrderingListPendingProductRequestViewModel[]) {
            state.list = list;
        },
        REMOVE_REQUESTPRODUCT(state, obj : ApproveOrderingListRequestProductCommand)
        {
            //remove product from list.
            state.list = state.list.filter(x => x.productKey != obj.productKey);
        },
        ADD_REQUESTPRODUCT(state, obj: AddOrderingListRequestProductCommand)
        {
            state.list.push(new OrderingListPendingProductRequestViewModel({
                productKey: obj.productKey
            }));
        }
    },
    actions: {
        async load(context, payload: any) : Promise<any> {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            if(payload.withUserInfo) promise = null;

            return promise || (promise = new Promise(async (resolve, reject) => {
                const client =  await ApiFactory.getOrderingListRequestProductClient()
                const result = await client.getAll(payload.withUserInfo);   
                commit.SET_List(result.list);
                resolve(result.list);
            })); 
        },
        async approve(context, requestProduct: ApproveOrderingListRequestProductCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            const client =  await ApiFactory.getOrderingListRequestProductClient()
            const result = await client.approve(requestProduct);   
            commit.REMOVE_REQUESTPRODUCT(requestProduct);
            
        },
        async cancel(context, requestProduct: CancelOrderingListRequestProductCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            const client =  await ApiFactory.getOrderingListRequestProductClient();
            const result = await client.cancel(requestProduct);   
            commit.REMOVE_REQUESTPRODUCT(requestProduct);
            
        },
        async request(context, requestProduct: AddOrderingListRequestProductCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            const client =  await ApiFactory.getOrderingListRequestProductClient();
            const result = await client.add(requestProduct);   
            commit.ADD_REQUESTPRODUCT(requestProduct);
        },
        
    }
    
});

export default orderingListRequestProduct
const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, orderingListRequestProduct);
const authActionContext = (context: any) => moduleActionContext(context, orderingListRequestProduct);